export enum PaymentStepStatus {
  NONE,
  WAITING,
  SUCCESS,
  FAILURE
}
